import loadable from '@loadable/component';

export const AsyncMarkerMap = loadable(
    () =>
        import(
            /* webpackChunkName: "map" */
            /* webpackPrefetch: true */
            './MarkerMap'
        ),
    {ssr: false}
);

AsyncMarkerMap.displayName = 'AsyncMarkerMap';
